import { getImageBasePath } from 'utils/generics';
import Image from 'next/image';
import * as Styles from '../styles';
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import React from 'react';

interface IProps {
    onClick: () => void;
}

const SuccessV1: React.FC<IProps> = (props: IProps) => {
    const { onClick } = props;
    return (
        <Styles.Wrapper>
            <Styles.TextBlock>Congratulations 🤩</Styles.TextBlock>
            <Styles.SubTextBlock>
                The protection plan has been issued for the customer and the
                details sent to their phone number and email.
            </Styles.SubTextBlock>
            <Styles.Banner>
                <Image
                    width={'250px'}
                    height={'250px'}
                    alt={''}
                    src={getImageBasePath('/images/Success.svg')}
                />
            </Styles.Banner>
            <Styles.TextBlock>Few Points to Remember 📌</Styles.TextBlock>
            <Styles.OrderedList type="a">
                <Styles.OrderListItem>
                    Please furnish the plan invoice to the customer
                </Styles.OrderListItem>
                <Styles.OrderListItem>
                    View your commission under Completed Transaction
                </Styles.OrderListItem>
            </Styles.OrderedList>
            <Styles.GoHomeButtonWrapper>
                <PrimaryButton onClick={onClick}>Got it</PrimaryButton>
            </Styles.GoHomeButtonWrapper>
        </Styles.Wrapper>
    );
};

export default SuccessV1;
